export { default } from './BannerNewWebsite';
